export default __webpack_public_path__ + "static/media/product15.95c1300a.webp";